module.exports = __webpack_public_path__ + "static/media/financehead2.e73a496a.jpg";